export const shouldRefreshAlerts = (user, event) =>
  Boolean(user?._id && event?.to?.includes(user?.role))

export const shouldNotifyAlert = (user, event) => {
  const notificationRecipients = event?.notifyTo || event?.to

  return Boolean(
    user?._id &&
      user?._id !== event?.userId &&
      notificationRecipients?.includes(user?.role)
  )
}
